/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/
import firebase from 'firebase';
import axios from '@/axios.js'
import Handlebars from 'handlebars';
import con from '@/firebase/firebaseInit.ts'
import ls from "@/common/localStorage"

//const cn = 'OA_UAT_C1591205467009E1591206650065'
var cn = ls.getSessionEventCollectionName();
const exhibitorRef = con.eventDB.collection(cn).doc('ExhibitorList').collection('Exhibitors');
const exhibitorTypeRef = con.eventDB.collection(cn).doc('ExhibitorTypeList').collection('Types');
const categoryRef = con.eventDB.collection(cn).doc("ExhibitorCategories").collection("Category");
var maitmplateRef = con.eventDB.collection(cn).doc("mailtpl").collection("Exhibitor");
const storageRef = con.storageRef;
var Session_TimeZone = ls.getSessionValueByKey('Session_Event_TZ');
var FetchExhibitorVisitoReportAPI = con.FetchExhibitorVisitoReportAPI;
var Session_Client_Id = ls.getSessionValueByKey('Session_Client_Id');
var Session_Event_Id = ls.getSessionValueByKey('Session_Event_Id');
var BusinessCardFetchAPI = con.BusinessCardFetchAPI;
var getBoothStats = con.getBoothStats;
var exhibitorMeeting = con.exhibitorMeeting;
var eventRef = con.eventDB.collection(cn).doc("EventInfo");
var clientRef = con.instanceDB.doc("ClientList").collection("Clients").doc(Session_Client_Id);
var BULKMAILAPINEW = con.BULKMAILAPINEW;

export default {
    fetchExhibitors({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            var sequence = [];
            exhibitorRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    var docObj = doc.data();
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    if(docObj.DisplaySequence != undefined){
                        sequence.push(docObj.DisplaySequence);

                    }
                    markers.push(docObj)
                })
                if(sequence.length > 0){
                    localStorage.setItem("AllExhibitorDisplaySequence", sequence);
                }
                commit('SET_EXHIBITORS', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchExhibitorsDropdown({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            exhibitorRef.get().then(querySnapshot => {

                querySnapshot.docs.forEach(doc => {
                    markers.push({ TopicId: doc.data().TableId, TopicName: doc.data().TableName })
                })
                commit('SET_EXHIBITORS', markers)
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchExhibitor(context, id) {
        //console.log(id)
        return new Promise((resolve, reject) => {
            if (id === null) {
                resolve({
                    status: 200,
                    data: {

                        BoothNo: '',
                        Category: '',
                        HtmlCode: '',
                        CreatedDate: '',
                        Email: '',
                        ExhibitorId: '',
                        HotspotImageURL: '',
                        LastModifiedDate: '',
                        Logo: '',
                        MappedContacts: [],
                        Name: '',
                        Phone: '',
                        PhoneCountryCode: '',
                        Profile: '',
                        IsPublished: true,

                        Resources: [],
                        ShowcaseImages: [],

                        ShowcaseVideoURL: '',
                        SocialLinks: [
                            { Facebook: '' },
                            { Twitter: '' },
                            { GooglePlus: '' },
                            { LinkedIn: '' }
                        ],
                        Website: '',
                        Type: {
                            TypeId: null,
                            TypeName: null,
                            BackgroundImg: null
                        },
                        mappedchatgroup: null,
                        RoundTableTopic: null,
                        PodiumDetails: {
                            CTALink: null,
                            Description: "",
                            KnowMoreLink: "",
                            Title: ""
                        }

                    }
                })
            } else {
                let docObj = new Object
                exhibitorRef.doc(`${id}`).get().then(function(doc) {
                    docObj = doc.data()
                    docObj.IsPublished = docObj.IsPublished == undefined ? false : docObj.IsPublished;
                    docObj.mappedchatgroup = docObj.mappedchatgroup ? docObj.mappedchatgroup : null;
                    docObj.RoundTableTopic = docObj.RoundTableTopic ? docObj.RoundTableTopic : null;
                    docObj.Type = docObj.Type ? docObj.Type : null;
                    docObj.PhoneCountryCode = docObj.PhoneCountryCode ? docObj.PhoneCountryCode : null;
                    if (docObj.HtmlCode == undefined) {
                        docObj.HtmlCode = "";
                    }
                    //console.log(doc.data().SocialLinks[0].Facebook)
                    docObj.SocialLinks = {
                        /*Facebook: doc.data().SocialLinks[0].Facebook,
                        Twitter: doc.data().SocialLinks[3].Twitter,
                        GooglePlus: doc.data().SocialLinks[1].GooglePlus,
                        LinkedIn: doc.data().SocialLinks[2].LinkedIn*/
                    }

                    docObj.PodiumDetails = docObj.PodiumDetails ? docObj.PodiumDetails : {CTALink: null, Description: "", KnowMoreLink: "", Title: ""};
                    
                    if (doc.data().SocialLinks) {
                        for (let i = 0; i < doc.data().SocialLinks.length; i++) {
                            let socialkeys = Object.keys(doc.data().SocialLinks[i])
                            let socialvaues = Object.values(doc.data().SocialLinks[i])
                            if (socialkeys[0] && socialvaues[0])
                                docObj.SocialLinks[socialkeys[0]] = socialvaues[0]
                        }
                    }

                    console.log(docObj.SocialLinks)
                    docObj.Resources = (doc.data().Resources ? doc.data().Resources : [])
                        //console.log(docObj)                      
                    resolve({ status: 200, data: docObj })
                }).catch(function(error) {
                    //console.log('Error getting mapped attendee:', error)
                    reject(error)
                })
            }

        })
    },
    updateStatus(context, field) {
        //console.log(field)
        debugger;
        return new Promise((resolve, reject) => {
            exhibitorRef.doc(`${field.id}`).update({
                    IsPublished: field.IsPublished,
                    LastModifiedDate: new Date()
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' });
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },

    // updateExhibitor(context, field) {
    //   //console.log(atob(field.id));
    //   console.log(field.id);
    //   return new Promise((resolve, reject) => {
    //       let docObj = {
    //           BoothNo:field.data.BoothNo,
    //           Category:field.data.Category,
    //           Email:field.data.Email,
    //           HotspotImageURL:field.data.HotspotImageURL,
    //           LastModifiedDate:new Date(),
    //           Logo:field.data.Logo,
    //           MappedContacts:field.data.MappedContacts ? field.data.MappedContacts : [],
    //           Name:field.data.Name,
    //           Phone:field.data.Phone,
    //           Profile:field.data.Profile,

    //           Resources:[],
    //           ShowcaseImages:[],

    //           ShowcaseVideoURL:field.data.ShowcaseVideoURL,
    //           // SocialLinks:[          
    //           //   {Facebook:field.data.SocialLinks.Facebook},
    //           //   {Twitter:field.data.SocialLinks.Twitter},
    //           //   {GooglePlus:field.data.SocialLinks.GooglePlus},
    //           //   {LinkedIn:field.data.SocialLinks.LinkedIn}
    //           // ],
    //           Website:field.data.Website
    //      }
    //      exhibitorRef.doc(`${field.id}`).update(docObj).then(function() {          
    //       resolve({status:200,message:'Data Updated.' })            
    //     }).catch(function (error) {
    //         console.log('Error updating session:', error)
    //         reject(error)
    //     }) 


    //   })
    // },


    updateExhibitor(context, field) {
        return new Promise((resolve, reject) => {
            let docObj = {
                    BoothNo: field.data.BoothNo,
                    Category: field.data.Category,
                    HtmlCode: field.data.HtmlCode,
                    Email: field.data.Email.trim(),
                    HotspotImageURL: field.data.HotspotImageURL,
                    LastModifiedDate: new Date(),
                    Logo: field.data.Logo,
                    MappedContacts: field.data.MappedContacts ? field.data.MappedContacts : [],
                    Name: field.data.Name.trim(),
                    Phone: field.data.Phone,
                    PhoneCountryCode: field.data.PhoneCountryCode ? field.data.PhoneCountryCode : null,
                    Profile: field.data.Profile,
                    IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,

                    //Resources:[],
                    ShowcaseImages: [],

                    ShowcaseVideoURL: field.data.ShowcaseVideoURL,
                    // SocialLinks:[          
                    //   {Facebook:field.data.SocialLinks.Facebook},
                    //   {Twitter:field.data.SocialLinks.Twitter},
                    //   {GooglePlus:field.data.SocialLinks.GooglePlus},
                    //   {LinkedIn:field.data.SocialLinks.LinkedIn}
                    // ],
                    Website: field.data.Website,
                    mappedchatgroup: field.data.mappedchatgroup,
                    RoundTableTopic: field.data.RoundTableTopic,
                    Type: field.data.Type,
                    DisplaySequence: field.data.displayOrder == undefined ? "" : parseInt(field.data.displayOrder),
                }
                if(field.data.Resources)
                {                    
                    docObj.Resources = field.data.Resources.filter(function(element) {
                       return typeof element == 'string';
                    });
                }
                if(field.data.ResourcesLink){
                    docObj.ResourcesLink = field.data.ResourcesLink;
                }
                console.log(field.data)
            exhibitorRef.doc(`${field.id}`).update(docObj)
                .then(function(doc) {
                    context.dispatch('resourceUpload', { Id: field.id, files: field.data.ResourceFiles }).then(resource => {
                        /*if (field.data.file) {
                            const file = field.data.file
                            const metadata = {
                                'contentType': file.type
                            }
                            console.log("field>>>>>>>>",field.data);
                            storageRef.child(`${cn}/Exhibitor/profileImage/${  new Date().getTime()  }_${  file.name}`).putString(field.data.Logo, 'data_url').then(function (snapshot) {
                                snapshot.ref.getDownloadURL().then(function(url) {
                                    exhibitorRef.doc(`${field.id}`).update({ Logo: url.toString() }).then(function(doc) {
                                        resolve({ status: 200, message: 'Data & File Updated.' })
                                    })
                                })
                            })
                        } else {
                            resolve({ status: 200, message: 'Data Updated.' })
                        }*/
                        resolve({ status: 200, message: 'Data Updated.' })
                    })

                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },


    // addExhibitor (context, field) {
    //   console.log(field); 
    //   return new Promise((resolve, reject) => { 
    //     //let ExhibitorID = "EX" + new Date().getTime();
    //     //let ExhibitorID = context.dispatch('getAutoId');
    //     let docObj = { 

    //       BoothNo:field.data.BoothNo,
    //       Category:field.data.Category,
    //       CreatedDate:new Date(),
    //       Email:field.data.Email,
    //       ExhibitorId:null,
    //       HotspotImageURL:field.data.HotspotImageURL,
    //       LastModifiedDate:new Date(),
    //       Logo:field.data.Logo,
    //       MappedContacts:field.data.MappedContacts ? field.data.MappedContacts : [],
    //       Name:field.data.Name,
    //       Phone:field.data.Phone,
    //       Profile:field.data.Profile,

    //        Resources:[],
    //        ShowcaseImages:[],

    //       ShowcaseVideoURL:field.data.ShowcaseVideoURL,
    //       SocialLinks:[          
    //         {Facebook:''},
    //         {Twitter:''},
    //         {GooglePlus:''},
    //         {LinkedIn:''}
    //       ],
    //       Website:field.data.Website
    //     }
    //     context.dispatch('getAutoId').then( AutoID => {
    //       docObj.ExhibitorId = AutoID;
    //         exhibitorRef.doc(`${AutoID}`).set(docObj).then(function () { 
    //           resolve({status:200, message:'Data Added.', Id: field.data.AutoID }) 
    //         }).catch(function (error) {
    //           //console.log(error);
    //           reject(error)
    //         }) 
    //     })    

    //   })
    // },



    addExhibitor(context, field) {
        //console.log(field); 
        return new Promise((resolve, reject) => {
            //let ExhibitorID = "EX" + new Date().getTime();
            //let ExhibitorID = context.dispatch('getAutoId');
            let docObj = {

                BoothNo: field.data.BoothNo,
                Category: field.data.Category,
                HtmlCode: field.data.HtmlCode,
                CreatedDate: new Date(),
                Email: field.data.Email.trim(),
                ExhibitorId: null,
                HotspotImageURL: field.data.HotspotImageURL,
                LastModifiedDate: new Date(),
                Logo: field.data.Logo,
                MappedContacts: field.data.MappedContacts ? field.data.MappedContacts : [],
                Name: field.data.Name.trim(),
                Phone: field.data.Phone,
                PhoneCountryCode: field.data.PhoneCountryCode ? field.data.PhoneCountryCode : null,
                Profile: field.data.Profile,
                IsPublished: field.data.IsPublished == undefined ? false : field.data.IsPublished,
                DisplaySequence: field.data.displayOrder == undefined ? "" : parseInt(field.data.displayOrder),
                AriealBoothImgURL: field.data.AriealBoothImgURL == undefined ? "" : field.data.AriealBoothImgURL,

                Resources: [],
                ShowcaseImages: [],
                UserRoles: [{
                        RoleID: 10,
                        RoleName: "AppUser"
                    },
                    {
                        RoleID: 12,
                        RoleName: "Exhibitor"
                    }
                ],

                ShowcaseVideoURL: field.data.ShowcaseVideoURL,
                SocialLinks: [
                    { Facebook: '' },
                    { Twitter: '' },
                    { GooglePlus: '' },
                    { LinkedIn: '' }
                ],
                Website: field.data.Website,
                mappedchatgroup: field.data.mappedchatgroup,
                RoundTableTopic: field.data.RoundTableTopic,
                Type: field.data.Type
            }
            context.dispatch('getAutoId').then(ExhibitorId => {
                docObj.ExhibitorId = ExhibitorId;
                exhibitorRef.doc(`${ExhibitorId}`).set(docObj).then(function() {
                    context.dispatch('resourceUpload', { Id: ExhibitorId, files: field.data.ResourceFiles }).then(resource => {
                        /*if (field.data.file) {
                            const file = field.data.file
                            const metadata = {
                                'contentType': file.type
                            }
                            storageRef.child(`${cn}/Exhibitor/profileImage/${  new Date().getTime()  }_${  file.name}`).putString(field.data.Logo, 'data_url').then(function (snapshot) {
                                snapshot.ref.getDownloadURL().then(function(url) {
                                    exhibitorRef.doc(`${ExhibitorId}`).update({ Logo: url.toString() }).then(function(doc) {
                                        resolve({ status: 200, message: 'Data & File Added.', Id: ExhibitorId })
                                    }).catch(function(error) {
                                        console.log('data update '+error)                
                                    })
                                }).catch(function(error) {
                                    console.log('download url '+error)                
                                })
                            }).catch(function(error) {
                                console.log('imgae upload '+error)                
                            })
                        } else {
                            resolve({ status: 200, message: 'Data Added.', Id: ExhibitorId })
                        }*/
                        resolve({ status: 200, message: 'Data Added.', Id: ExhibitorId })
                    })
                }).catch(function(error) {
                    console.log(error)
                    reject(error)
                })
            });



        })
    },



    updateExhibitorSocialDetail(context, field) {
        //alert(field.id)
        return new Promise((resolve, reject) => {
            exhibitorRef.doc(`${field.id}`).update({
                    SocialLinks: [
                        { Facebook: (field.data.SocialLinks.Facebook ? field.data.SocialLinks.Facebook : '') },
                        { GooglePlus: (field.data.SocialLinks.GooglePlus ? field.data.SocialLinks.GooglePlus : '') },
                        { LinkedIn: (field.data.SocialLinks.LinkedIn ? field.data.SocialLinks.LinkedIn : '') },
                        { Twitter: (field.data.SocialLinks.Twitter ? field.data.SocialLinks.Twitter : '') }
                    ]
                })
                .then(function(doc) {
                    resolve({ status: 200, message: 'Social Data Updated.' })
                }).catch(function(error) {
                    //console.log('Error getting update attendee:', error)
                    reject(error)
                })
        })
    },

    updatePodiumDetails(context, field) {
        return new Promise((resolve, reject) => {
            exhibitorRef.doc(`${field.id}`).update({PodiumDetails: field.data.PodiumDetails})
                .then(function(doc) {
                    resolve({ status: 200, message: 'Data Updated.' })
                }).catch(function(error) {
                    reject(error)
                })
        })
    },

    fetchExhibitorTypes({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            exhibitorTypeRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                commit('SET_EXHIBITORTYPES', markers)
                resolve(markers)
            }).catch(function(error) {
                reject(error)
            })
        })
    },

    addExhibitorType(context, field) {
        return new Promise((resolve, reject) => {
            context.dispatch('getAutoId').then(TypeId => {
                context.dispatch('uploadImage', { path: cn + '/Exhibitor/Types/BackgroundImg/', file: field.file }).then(BackgroundImgURL => {
                    let docObj = {
                        TypeId: TypeId,
                        TypeName: field.data.TypeName.trim(),
                        BackgroundImg: BackgroundImgURL
                    }
                    exhibitorTypeRef.doc(`${TypeId}`).set(docObj).then(function() {
                        resolve({status:200, message: 'Data Added Successfully.', TypeId: TypeId});
                    }).catch((error) => {
                        reject(error)
                    });
                })
            })
        })
    },

    updateExhibitorType(context, field) {
        return new Promise((resolve, reject) => {
            context.dispatch('uploadImage', { path: cn + '/Exhibitor/Types/BackgroundImg/', file: field.file }).then(BackgroundImgURL => {
                let docObj = {
                    TypeName: field.data.TypeName.trim(),
                    BackgroundImg: BackgroundImgURL ? BackgroundImgURL : field.data.BackgroundImg
                }
                exhibitorTypeRef.doc(`${field.TypeId}`).update(docObj).then(function(docRef) {
                    resolve({status:200, message: 'Data Updated Successfully.'});
                }).catch((error) => {
                    reject(error)
                });
            })
        })
    },

    async getAutoId(context) {
        let AutoId = 0;
        let promise = new Promise((resolve, reject) => {
            con.instanceDB.doc("AutoID").get().then(function(doc) {
                if (!doc.exists) {
                    con.instanceDB.doc("AutoID").set({ UserId: 0 })
                    resolve(1)
                } else {
                    con.instanceDB.doc("AutoID").update({
                        UserId: firebase.firestore.FieldValue.increment(1)
                    }).then(function() {
                        con.instanceDB.doc("AutoID").get().then(function(doc) {
                            resolve(doc.data().UserId)
                        })
                    })
                }
            })
        })

        AutoId = await promise;
        AutoId = AutoId * 1000;
        return AutoId.toString();
    },
    resourceUpload(context, obj) {
        return new Promise((resolve, reject) => {
            if (obj.files && obj.files.length) {
                let count = 0;
                for (var i = 0; i < obj.files.length; i++) {
                    let file = obj.files[i]
                    let metadata = {
                        'contentType': file.type
                    }
                    storageRef.child(`${cn  }/Exhibitor/Resources/${  file.name}`).put(file, metadata).then(function(snapshot) {
                        snapshot.ref.getDownloadURL().then(function(url) {
                            exhibitorRef.doc(`${obj.Id}`).update({ Resources: firebase.firestore.FieldValue.arrayUnion(url.toString()) }).then(function(doc) {
                                count = count + 1;
                                if (obj.files.length == count)
                                    resolve({ status: 200, message: 'Files Updated.' })
                            })
                        })
                    })
                }
            } else {
                resolve({ status: 200, message: 'Files Updated.' })
            }
        })
    },
    getSettings(context) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('Exhibitor').doc('ExhibitorSettings').get().then(function(doc) {
                if (doc.exists) {
                    resolve(doc.data())
                } else {
                    resolve({ IsEnhancedHotspotting: false })
                }

            })
        })
        return promise;
    },
    saveSettings(context, field) {
        let promise = new Promise((resolve, reject) => {
            con.eventDB.collection(cn).doc("Settings").collection('Exhibitor').doc('ExhibitorSettings').get().then(function(doc) {
                if(field.IsDefaultSettings)
                {
                    field.settingsData.DefaultSettingsLoaded = true;
                    context.dispatch('loadDefaultSettings');
                }
                if (doc.exists) {
                    let ExpoHallBackgroundImage = doc.data().ExpoHallBackgroundImage ? doc.data().ExpoHallBackgroundImage : null
                    context.dispatch('uploadImage', { path: cn + '/Exhibitor/Settings/', file: field.ExpoHallBackgroundImageFile }).then(ExpoHallBackgroundImageURL => {
                        let docObj = field.settingsData;
                        docObj.ExpoHallBackgroundImage = ExpoHallBackgroundImageURL ? ExpoHallBackgroundImageURL : ExpoHallBackgroundImage
                        con.eventDB.collection(cn).doc("Settings").collection('Exhibitor').doc('ExhibitorSettings').update(docObj).then(function(){
                            resolve({ message: 'Data Updated.' })
                        })                        
                    })
                } else {
                     context.dispatch('uploadImage', { path: cn + '/Exhibitor/Settings/', file: field.ExpoHallBackgroundImageFile }).then(ExpoHallBackgroundImageURL => {
                        let docObj = field.settingsData;
                        docObj.ExpoHallBackgroundImage = ExpoHallBackgroundImageURL ? ExpoHallBackgroundImageURL : null
                        con.eventDB.collection(cn).doc("Settings").collection('Exhibitor').doc('ExhibitorSettings').set(docObj).then(function(){
                            resolve({ message: 'Data Updated.' })
                        })                        
                    })
                }

            })
        })
        return promise;
    },
    loadDefaultSettings({ commit }){
        let promise = new Promise((resolve, reject) => {
            maitmplateRef.doc("BusinessCardAttendee").get().then(function(mailtpl) {
                if (mailtpl.exists) {
                    resolve("Template Exists")
                }
                else
                {
                    con.instanceDB.doc("mailtpl").collection("Exhibitor").doc('BusinessCardAttendee').get().then(function(mailtplinstnc) {
                        if (mailtplinstnc.exists) {
                            maitmplateRef.doc('BusinessCardAttendee').set(mailtplinstnc.data()).then(function() {
                                resolve("Template Created from instance")
                            })
                        }
                        else
                        {

                            maitmplateRef.doc('BusinessCardAttendee').set({designJson:'',html:'',subject:''}).then(function() {
                                resolve("Blank Template Created")
                            })
                        }
                    })
                }
            })
            maitmplateRef.doc("BusinessCardExhibitor").get().then(function(mailtpl) {
                if (mailtpl.exists) {
                    resolve("Template Exists")
                }
                else
                {
                    con.instanceDB.doc("mailtpl").collection("Exhibitor").doc('BusinessCardExhibitor').get().then(function(mailtplinstnc) {
                        if (mailtplinstnc.exists) {
                            maitmplateRef.doc('BusinessCardExhibitor').set(mailtplinstnc.data()).then(function() {
                                resolve("Template Created from instance")
                            })
                        }
                        else
                        {

                            maitmplateRef.doc('BusinessCardExhibitor').set({designJson:'',html:'',subject:''}).then(function() {
                                resolve("Blank Template Created")
                            })
                        }
                    })
                }
            })
        })
        return promise;
    },
    uploadImage(context, field) {
        return new Promise((resolve, reject) => {
            if (field.file && field.path) {
                let path = field.path;
                let file = field.file
                let metadata = {
                    'contentType': file.type
                }
                storageRef.child(path + (new Date().getTime()) + "_" + file.name).put(file, metadata).then(function(snapshot) {
                    snapshot.ref.getDownloadURL().then(function(url) {
                        resolve(url.toString())
                    })
                })
            } else {
                resolve(null)
            }
        })
    },
    changeStatus(context, field) {
        return new Promise((resolve, reject) => {
                let totallength = field.data.length;
                let count = 0;
                for (var i = 0; i < field.data.length; i++) {
                    let data = field.data[i]
                    exhibitorRef.doc(`${data.ExhibitorId}`)
                        .update({ IsPublished: field.Status })
                        .then(function() {

                            count = count + 1;
                            if (totallength == count)
                                resolve({ status: 200, message: 'Status Changed of ' + count + ' Record' })
                        })
                }
            }) // end of promise
    },
    deleteResource(context, field) {
        return new Promise((resolve, reject) => {
            if(field.link){
                exhibitorRef.doc(`${field.id}`).update({                    
                    ResourcesLink: firebase.firestore.FieldValue.arrayRemove({ Title: field.name, Link: field.fileLink })                    
                }).then(function(e) {
                    resolve({ status: 200, message: 'resource deleted'})
                });
            }else{
                exhibitorRef.doc(`${field.id}`).update({                    
                    Resources: firebase.firestore.FieldValue.arrayRemove(field.name)                    
                }).then(function(e) {
                    resolve({ status: 200, message: 'resource deleted'})
                });
            }
          
        })
    },
    removeRecord({ commit }, userId) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/user-management/users/${userId}`)
                .then((response) => {
                    commit('REMOVE_RECORD', userId)
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    fetchCategory({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            categoryRef.get().then(querySnapshot => {
                querySnapshot.docs.forEach(doc => {
                    markers.push(doc.data())
                })
                resolve(markers)
            }).catch(function(error) {
                //console.log('Error getting attendee:', error)
                reject(error)
            })

        })
    },
    fetchExhibitorVisitorReport(context, exhibitorId) {
        var hours =  (5000 * 24);
        return new Promise((resolve, reject) => {
            var mObj = {};
            const markers = []
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "exhibitorId": exhibitorId,
                "numHours": hours
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(FetchExhibitorVisitoReportAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    mObj.userName = row4.userName;
                    mObj.userEmail = row4.userEmail;
                    mObj.viewDtm = row4.viewDtm;
                    markers.push(mObj);
                    mObj = {};
                });
                resolve({ status: 200, data: markers })
            }).catch((error) => {
                console.log('Error fetching exhibitor visitor report data==:', error)
            })

        })

    },
    saveStreamingClientZoom(context, field){
        return new Promise((resolve, reject) => {
            let tableObj = {
                ExhibitorId: field.ExhibitorId,
                ContactId: field.AttendeeObj.AttendeeId,
                Host: [field.AttendeeObj],
                Duration: 120,
                CoHost: null,
                StreamingClient: field.StreamingClient,
                TableName: `${field.exhibitorDetail.Name} - ${field.AttendeeObj.FirstName}`,
                Timezone: ls.getSessionValueByKey('Session_Event_TZ')
            }
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "key": {
                    "eventId": Session_Event_Id,
                    "clientId": Session_Client_Id,
                    "instanceId": "OA_UAT"                    
                },
                "data": tableObj
            }
            //context.dispatch("roundtableManagement/createZoomMeeting", tableObj, {root:true}).then(res=>{
            axios.post(exhibitorMeeting, requestData, { headers: headers }).then((res) => {
                //console.log(response)
                if(res.status == 200){
                    let MappedContacts = [];
                    let Zoom_Detail = res.data ? res.data : null;
                    exhibitorRef.doc(`${field.ExhibitorId}`).get().then(function(doc) {
                        doc.data().MappedContacts.filter(row=>{
                            if(row.AttendeeId == field.AttendeeObj.AttendeeId && Zoom_Detail)
                            {
                                row.StreamingClient = "Zoom"
                                row.Zoom_Detail = Zoom_Detail
                            }
                            MappedContacts.push(row)
                        })
                        exhibitorRef.doc(`${field.ExhibitorId}`).update({MappedContacts:MappedContacts}).then(function(){
                            resolve({ status: 200, message: "Meeting Created Successfully." })
                        })
                    })
                }
                else
                {
                    resolve({ status: 500, message: res.data })
                }
            })
        })
    },
    fetchBusinessCardDetails({ commit }) {
        return new Promise((resolve, reject) => {
            const markers = []
            var mObj = {};
            var bussnssCrdDta = [];
    
            var hours = (5000 * 24);
            let requestData = {
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "numHours": hours
            }
            let headers = {
                "content-type": "application/json"
            }
            axios.post(BusinessCardFetchAPI, requestData, { headers: headers }).then((response) => {
                response.data.rows.map((row4) => {
                    mObj.ExchangedByName = row4.visitorName;
                    mObj.ExchangedByEmail = row4.visitorEmail;
                    mObj.ExchangedWithBoothId = row4.boothId;
                    mObj.ExchangedWithBoothName = row4.boothName;
                    mObj.DeviceInfo = row4.device;
                    mObj.CreatedDate = row4.createDtm
                    bussnssCrdDta.push(mObj)
                    mObj = {};
                });
                resolve({ status: 200, data: bussnssCrdDta })
            }).catch((error) => {
                console.log('Error fetching business card exchange data==:', error)
            })

        })
    },
    getBoothStats(context, field) {
        return new Promise((resolve, reject) => {
            let headers = {
                "Content-Type": "application/json",
                'Authorization': `Bearer ${ls.getSessionValueByKey('Session_AccessToken')}`
            }
            let requestData = {
                "eventId": Session_Event_Id,
                "clientId": Session_Client_Id,
                "instanceId": "OA_UAT",
                "exhibitorId": field.exhibitorId,
                "numDays": 365
            }

            axios.post(getBoothStats, requestData, { headers: headers }).then(response => {
                //console.log(response.data)
                resolve(response.data);
            }).catch(err=>{ reject(err) });

        });
    },
    getMailTemplate(context) {
    var html = '';
    let subject = '';
    var count = 0;
    let promise = new Promise((resolve, reject) => {
        clientRef.get().then(function (clientDetail) {
            eventRef.get().then(function (eventDetail) {
                //let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventStartDate.seconds * 1000).toLocaleTimeString('en-US');
                let EndDate = new Date(eventDetail.data().EventEndDate.seconds * 1000).toDateString() + " " + new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US');

                let StartDate = new Date(eventDetail.data().EventStartDate.seconds * 1000).toDateString()
                let StartTime = new Date(eventDetail.data().EventEndDate.seconds * 1000).toLocaleTimeString('en-US')

                let formatedText = {
                    CustomDomain: clientDetail.data().CustomDomain,
                    EventName: eventDetail.data().EventFullName,
                    Email: "Email",
                    Password: "Password",
                    FirstName: "First Name",
                    StartDate: StartDate,
                    StartTime: StartTime,
                    EndDate: EndDate,
                    EventAccessCode: atob(eventDetail.data().defaultEP),
                    EventAccessURL: `${clientDetail.data().CustomDomain}/#${eventDetail.data().EventId}`,
                    EventId: eventDetail.data().EventId,
                    //addtocalendarStartDate: addtocalendarStartDate,
                    //addtocalendarEndDate: addtocalendarEndDate,
                    EventBanner: eventDetail.data().EventBanner,
                    ClientName: clientDetail.data().ClientName,
                    ClientAddress: "Client address if present"
                };
                let Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");
                let reminderMailDoc = Sesion_EventAccessType == 'Use Common Event Passcode' ? 'Reminder' : 'Reminder';
                maitmplateRef.doc(reminderMailDoc).get().then(function (mailtpl) {
                    if (mailtpl.exists) {
                        let sourcehtml = (mailtpl.data().html ? mailtpl.data().html : '')
                        let template = Handlebars.compile(sourcehtml);
                        let formatedhtml = template(formatedText);
                        html = (formatedhtml ? formatedhtml : 'Template not set!')
                        subject = (mailtpl.data().subject ? mailtpl.data().subject : null)
                        resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                    } else {
                        con.instanceDB.doc("mailtpl").collection("ReminderMail").doc(reminderMailDoc).get().then(function (mailtplinstnc) {
                            if (mailtplinstnc.exists) {
                                maitmplateRef.doc(reminderMailDoc).set({ html: mailtplinstnc.data().html, subject: mailtplinstnc.data().subject }).then(function () {
                                    let sourcehtml = (mailtplinstnc.data().html ? mailtplinstnc.data().html : '')
                                    let template = Handlebars.compile(sourcehtml);
                                    let formatedhtml = template(formatedText);
                                    html = (formatedhtml ? formatedhtml : 'Template not set!')
                                    subject = (mailtplinstnc.data().subject ? mailtplinstnc.data().subject : null)
                                    resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                                })
                            } else {
                                html = 'Template not set!'
                                subject = null
                                sourcehtml = null
                                resolve({ html: html, subject: subject, sourcehtml: sourcehtml })
                            }

                        })
                    }

                })
            })
        })
    }) // end of promise

    return promise;
},
sendMail(context, field) {
    let promise = new Promise((resolve, reject) => {
        const headers = {
            "Content-Type": "application/json"
        }

        var requestData = {
            key:{
                "instanceId": "OA_UAT",
                "clientId": Session_Client_Id,
                "eventId": Session_Event_Id,
                "recipientType": "Exhibitor",
                "templatePath": "/mailtpl/Exhibitor/Reminder"
            },
            data: field.data
        }

        axios.post(BULKMAILAPINEW, requestData, { headers: headers }).then((response) => { 
            if(response.data.status == 0)
                resolve({ status: 200, message: 'Mail sent to Users.' })
            else
                resolve({ status: 500, message: 'Mail not sent!' })
        })
            .catch((error) => { reject(err) })

    }) // end of promise

    return promise;

},
    saveMail(context, field) {
        let sourcehtml = field.sourcehtml
        let subject = field.subject
        let Sesion_EventAccessType = ls.getSessionValueByKey("Sesion_EventAccessType");
        let promise = new Promise((resolve, reject) => {
            let reminderMailDoc = Sesion_EventAccessType == 'Use Common Event Passcode' ? 'Reminder' : 'Reminder';
                maitmplateRef.doc(reminderMailDoc).update({
                    html: sourcehtml,
                    subject: subject
                }).then(function () {
                    resolve({ message: "Mail Template Saved." })
                })
        })
        return promise;
    },

}